import { useState, useEffect } from 'react';
import { apiB2B, apiB2C } from '../api/axios-client';
import { isLoggedIn } from '../utils/user';
import { ERR_REDIRECT } from '../constants/response-error-messages';
import { gatherAllParamsToString } from '../components/Utils';
// Endpoints that should handle 404 gracefully without redirecting to sign-in
var ENDPOINTS_ALLOW_404 = ['/challenges/challengesInfo'];
export var useInterceptors = function () {
    var _a = useState(null), redirectError = _a[0], setRedirectError = _a[1];
    useEffect(function () {
        if (!isLoggedIn()) {
            redirectToSignIn();
        }
    }, []);
    var redirectToSignIn = function () {
        var params = gatherAllParamsToString('&');
        window.location.replace("/auth/view/signin?redirect=".concat(window.location.pathname).concat(params));
        setRedirectError(ERR_REDIRECT);
    };
    var shouldAllowError = function (url, status) {
        if (status === 404) {
            return ENDPOINTS_ALLOW_404.some(function (endpoint) { return url.includes(endpoint); });
        }
        return false;
    };
    var logonMiddleware = function (error) {
        var response = error.response, config = error.config;
        if (response &&
            (response.status === 401 ||
                response.status === 431 ||
                (response.status === 404 &&
                    !shouldAllowError((config === null || config === void 0 ? void 0 : config.url) || '', response.status)))) {
            redirectToSignIn();
        }
        return Promise.reject(error);
    };
    apiB2B.interceptors.response.use(undefined, logonMiddleware);
    apiB2C.interceptors.response.use(undefined, logonMiddleware);
    return {
        redirectError: redirectError,
    };
};
